import dayjs from 'dayjs';

import { ApiRoutes } from '../constant/api';
import { api } from '../helpers/axios';
import {
	IDeletePersonalPlaceRequest,
	IFinishPersonalPlaceRequest,
	IPersonalPlaceFreeRequest,
	IPersonalPlacesReleaseResponse,
	IUpdatePersonalPlaceRequest,
} from '../types/personalPlaces.types';
import {IObjectsResponseType} from "@/shared/types/bookingObjects.types.ts";

export const personalPlacesApi = {
	getAllPersonalPlaces: () => api.get<IObjectsResponseType>(`${ApiRoutes.Objects}/personal`).then(res => res.data.objects),
	setPersonalPlaceFree: (payload: IPersonalPlaceFreeRequest) =>
		api.post(`${ApiRoutes.Objects}/release`, {
			...payload,
			collision_action: 'merge',
		}),
	getPersonalPlaces: () =>
		api
			.get(`${ApiRoutes.Objects}/release`, {
				params: {
					fetch: 0,
					start: dayjs().toISOString(),
					finish: dayjs().add(30, 'day').toISOString(),
				},
			})
			.then((res) => (res.data as IPersonalPlacesReleaseResponse)?.objects),
	updatePersonalPlaceAccess: (payload: IUpdatePersonalPlaceRequest) =>
		api.put(`${ApiRoutes.Objects}/release`, {
			...payload,
		}),
	finishPersonalPlaceAccess: (payload: IFinishPersonalPlaceRequest) =>
		api.put(`${ApiRoutes.Objects}/release`, {
			...payload,
		}),
	deletePersonalPlaceAccess: (payload: IDeletePersonalPlaceRequest) =>
		api.delete(`${ApiRoutes.Objects}/release`, {
			data: { ...payload },
		}),
};
